import { Component, OnInit, ViewChild, ElementRef,HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { EmailchecklistreportsService } from './emailchecklistreports.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { NgxCarousel } from 'ngx-carousel';
import { CospService } from '../cosp/cosp.service';
import { ReportsService } from '../reports/reports.service';
import { ChecklistService } from '../checklist/checklist.service';
import { CrewService } from '../crew/crew.service';
import { CompanyService } from '../company/company.service';
//import jsPDF from 'jspdf';
//import html2canvas from "html2canvas";
import { SessionStorageService } from 'angular-web-storage';
import { VesselsService } from '../vessels/vessels.service';
//import { SessionStorageService } from 'angular-web-storage';

import domtoimage from 'dom-to-image';
import * as jsPDF from 'jspdf';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as _ from "lodash";
import { CookieService } from 'ngx-cookie-service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { AppCommonService } from 'src/app/app.common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-emailchecklistreports',
  templateUrl: './emailchecklistreports.component.html',
  styleUrls: ['./emailchecklistreports.component.scss']
})
export class EmailchecklistreportsComponent implements OnInit {
  displayedColumns: string[] = ['checklistName', 'Name' ,'Rank' ,'actionDate'  ,'actionTime' ,'edit'];
  dataSource = new MatTableDataSource()

  isLoading = true;
  myForm: FormGroup;
  afs: any;
  success: boolean;
  loading: boolean;
  data: any = [];
  allCategory: any = [];
  allChecklist: any = [];
  allQuestionAnswer: any = [];
  allQuestionAnswerList: any = [];
  allHeaderNotes : any =[];
  allFooterNotes : any =[];
  allFooterBottomNotes : any =[];
  checklistdetails:any;
  formBuilder: any = [];
  showReports:any;
  vesselId:any;
  vesselName:any;
  revisionDate:any;
  allAuthorizedBy:any = [];
  checklistAuthorizedBy:any = [];
  checklistToBeAuthorized:any = [];
  reportHeader:any = [];
  questionAnswerUser:any = [];
  authorizedBy:any=[];
  approvedIds:any;
  approvalDetail:any = [];
  allSectionQuestionAnswer:any = [];
  checkListName:any;
  groupedAnswer:any = [];
  cookieIp:any;
  checklistAdditionalInfo =[];
  companyId:any;
  companyName:any;
  companyImage:any;
  userVesselData:any = [];
  companyList:any = [];
  currentVessel:string;
  selectedCompany:string;
  checklistId:any;
  reportLoader:any=false;
  public Config: NgxCarousel =  {
    grid: {xs: 2, sm: 3, md: 3, lg: 5, all: 0},
    slide: 1,
    speed: 5,
    interval: 10000,
    point: {
      visible: true
    },
    touch: true,
    loop: false,
    custom: 'banner'
  };

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild('successbox', {static: true}) successbox: SwalComponent;
  @ViewChild('errorbox', {static: true})  errorbox: SwalComponent;

  constructor(private cookieService: CookieService,private domSanitizer: DomSanitizer,public cmps: CompanyService,public crewService: CrewService, public checklistService: ChecklistService, public rs: ReportsService,public vs: VesselsService, public cs: CospService,public session: SessionStorageService,public fb: FormBuilder, public checklistreportsService: EmailchecklistreportsService,
    public http: HttpClient,
    public datePipe: DatePipe,
    private route: ActivatedRoute,
    public commonService: AppCommonService,
    private router: Router
    ) {}

  ngOnInit() {
    this.reportLoader=true;
    this.session.set('userid',1)
    this.session.set('rolename','Super Admin')
    //this.getAllRole();
    this.route.paramMap.subscribe(result =>{
      console.log(`checkListName : ${result.get('checkListName')}`);
      console.log(`checklistId : ${result.get('checklistId')}`);
      console.log(`vesselId : ${result.get('vesselId')}`);
      console.log(`actionDate : ${result.get('actionDate')}`);
      console.log(`actionTime : ${result.get('actionTime')}`);

      this.checkListName=result.get('checkListName');
      this.checklistId =result.get('checklistId');
      this.vesselId=result.get('vesselId');
      this.addReportDetails(this.checklistId,result.get('actionDate'),result.get('actionTime'));
    })

    // this.session.set('userid',1)
    // this.session.set('rolename','Super Admin')
    // this.reportLoader=true;
    // this.checkListName='ABC';
    // this.checklistId = 185;
    // this.vesselId=1;
    // this.getAllRole();
    // this.addReportDetails(this.checklistId,"29-Jul-2023","12:15");

    //   this.cookieIp = this.cookieService.get('campbell_app_ip_address');

    //    var companyid = this.session.get('companyId');

    //    if(companyid){
    //         this.getVesselList(companyid);
    //    }else{
    //        this.getCompanyList();
    //    }

    //   this.companyId = this.session.get('companyId');
    //   if(this.companyId>0){
    //       this.getCompanyDetails(this.companyId);
    //   }

    //   if(this.session.get('passcode')){
    //         this.rs.getLatestCOSPByPasscode(this.session.get('passcode'),(response) => {
    //             const responseData = response.data;
    //             if(response.responsecode == 200) {
    //                 console.log('vesselId' + responseData.vesselId)
    //                 this.getVesselDetailsById(responseData.vesselId);
    //                    this.vesselId = responseData.vesselId;
    //                    this.vesselName = responseData.shipName;
    //                    this.currentVessel = this.vesselId;
    //             }
    //         })
    //     }


    //   this.myForm = this.fb.group({
    //   'bookTypeId':new FormControl(null, [Validators.required])
    // })

    // this.allCategory=[];
    // this.checklistreportsService.getAllCat((response) => {
    //   this.allCategory = response.data;
    //   console.log(this.allCategory);
    // })

    // of(this.dataSource).pipe(delay(1000))
    //  .subscribe(data => {
    //    this.isLoading = false;
    //    this.data = data
    //  }, error => this.isLoading = false);
  }

  getCompanyList(){

      this.cmps.getData((response) => {
           console.log('====company====')
           console.log(response.data);
           this.companyList = response.data;
       });
  }

  selectCompany(id){
      this.getVesselList(id);
  }

  getVesselList(id){
       this.vs.getDataByCompanyId(id,(response) => {
                    console.log(response);
                    this.userVesselData = response.data;

            })
  }

  getVesselDetailsById(id){
       this.vs.getDataById(id,(response) => {
                    console.log('vessel===data');
                    console.log(response);
                    this.selectedCompany = response.data.companyId;
                    this.getVesselList(response.data.companyId);
            })
  }

  getVesselData(event){
      console.log(event);
      for(let key in this.userVesselData){
          if(this.userVesselData[key].id==event){
               this.vesselId = event;
               this.vesselName = this.userVesselData[key].shipName;
               this.allChecklist = [];
               this.allQuestionAnswer = [];
               this.allSectionQuestionAnswer = [];
               this.questionAnswerUser = [];
               this.showReports=false;
               this.checklistdetails = false;

          }
      }
  }

  getCompanyDetails(id){
       this.cmps.getDataById(id,(response) => {
           console.log('====company====')
           console.log(response.data)
           this.companyName = response.data.companyName;
           this.companyImage = response.data.profileImage;
       });
  }

  onReportClick(cat){

   this.showReports=false;
   this.checklistdetails = false;
   if(cat.id){
    this.allChecklist = [];

    this.checklistreportsService.getAllChecklistByCatId(cat.id, (response) => {
      this.allChecklist = response.data;
      console.log('==allChecklist==');
      console.log(this.allChecklist);

    })
   }
}


getChecklistDetailsList(checklist){

    this.checklistdetails = false;
    this.showReports=false;
    this.checklistreportsService.getChecklistAnswerDetailsApprovalByChecklistIdAndFromDateAndToDate(this.vesselId,checklist.id, (response) => {
        var resData = response.data;
         console.log("RESPONSE"+ resData);
        if(resData!=undefined){
          this.allQuestionAnswerList = response.data;
          console.log('==allQuestionAnswerList==');
          console.log(this.allQuestionAnswerList);
          this.checklistdetails = checklist;
          this.checkListName = response.data[0].checklistName;
          this.dataSource = new MatTableDataSource(response.data);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
        }
    })


}


getFormdataAllforms1(checklist) {
  var fromDate = (document.getElementById("dp4") as HTMLInputElement).value;
  fromDate = this.datePipe.transform(fromDate, "dd-MMM-yyyy");
  var toDate = (document.getElementById("dp3") as HTMLInputElement).value;
  toDate = this.datePipe.transform(toDate, "dd-MMM-yyyy");
  var searchValue = (document.getElementById("searchValue") as HTMLInputElement).value;
  if(!searchValue){
    searchValue=null;
  }
  //var watchHour = this.selectedValueWatch;
  // alert("=hid="+hid+"=fromDate="+fromDate+'=toDate='+toDate+'==watchHour=='+watchHour);
  if (fromDate == null) {
    //return alert("From Date is required");
  }
  this.checklistdetails = false;
  this.showReports=false;
  this.checklistreportsService.getChecklistAnswerDetailsApprovalByChecklistIdAndFromDateAndToDateUsingGET(this.vesselId, checklist.id,fromDate,toDate,searchValue, (response) => {
      var resData = response.data;
       console.log("RESPONSE"+ resData);
      if(resData!=undefined){
        this.allQuestionAnswerList = response.data;
        console.log('==allQuestionAnswerList==');
        console.log(this.allQuestionAnswerList);
        this.checklistdetails = checklist;
        this.checkListName = response.data[0].checklistName;
        this.dataSource = new MatTableDataSource(response.data);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
      }
  })
}

in_array(array, id) {
    return array.some(function(o){return o["section"] === id;})
}

modifyedData(response){
                        console.log('==========response1============')
                         console.log(response);
//                         for(let row in response.data){
//                             response.data[row].rowId = response.data[row].rowId.replace('rowId','');
//                         }
                         console.log('==========response after change rowId============')
                         console.log(response.data);
                         var groupedCollection = [];
                         //groupedCollection = _.sortBy(response.data, 'timeStamp' );
                         groupedCollection = _.groupBy(response.data, 'questionId' );
                         console.log('==========response after grouped and sort============')
                         console.log(groupedCollection);
                         //response.data = groupedCollection;
                         console.log('==========response after grouped and sort============')
                         //console.log(response.data);
                         response.data = [];
                         var cnt = 0;
                         let value = [];
                         for (const [key, value] of Object.entries(groupedCollection)) {
                          console.log("===value===",value);
                             for(let arr in value){
                                     if(parseInt(arr)>0){
                                            value[parseInt(arr)-1]['ans'] = value[parseInt(arr)-1]['answer'];
                                            //var changeControlIds = value[arr].changeFields.toString().split(",");
                                             //for(let tey in value[arr]){
                                              // if(changeControlIds.indexOf(tey)!=-1){
                                                    if(value.length>1){value[arr]['isDelete'] = '1'};
                                                    if(value[parseInt(arr)-1]!=null){
                                                       value[parseInt(arr)-1]['editedBy'] = '<span class="box-edit-time">Edited On: '+value[parseInt(arr)].createdAt+ '<br> Edited By: ' + value[parseInt(arr)].userName + '</span>';
                                                       value[parseInt(arr)-1]['answer'] = '<strike>'+value[parseInt(arr)-1]['answer']+'</strike> &nbsp; <b>'+value[parseInt(arr)]['answer']+'</b>';
                                                    }
                                               // }
                                            //}
                                     }else{
                                      value[0]['ans'] = value[0]['answer'];
                                     }

                                    response.data.push(value[arr]);
                             }
                          }

                         console.log('==========response after grouped and sort and managed for edited ============')
                         console.log(response.data);
                         //return;
                         return response;
}

createCollectionLayout(collection){
  console.log("before html pop")
  console.log(collection);
                      for(let key in collection){
                          var rowdata = collection[key].value;
                         // console.log(collection[key]); return;
                                          //for(let pey in collection[key]){
                                              if(rowdata['answer']!=null && rowdata['answer'].indexOf("<b>")!=-1){

                                                  var oldValue = rowdata['answer'];
                                                  var newValue = rowdata['answer'];

                                                   if(oldValue.indexOf('box-edit-top')==-1){

                                                  var bold = oldValue.split('<b>').pop().split('</b>')[0];
                                                      oldValue = oldValue.replace(bold,'').replace('<b></b>','');

                                                      if(oldValue.indexOf('<b>')!=-1){
                                                        bold = oldValue.split('<b>').pop().split('</b>')[0];
                                                        oldValue = oldValue.replace(bold,'').replace('<b></b>','');
                                                      }




                                                  var strike = newValue.split('<strike>').pop().split('</strike>')[0];
                                                      newValue = newValue.replace(strike,'').replace('<strike></strike>','')

                                                      if(newValue.indexOf('<strike>')!=-1){
                                                        strike = newValue.split('<strike>').pop().split('</strike>')[0];
                                                        newValue = newValue.replace(strike,'').replace('<strike></strike>','')
                                                      }

                                                      if(oldValue.indexOf("<strike></strike>")==-1)
                                                      rowdata['answer'] = '<div class="box-edit-top">' + oldValue.replace(/<strike>/gi,'<strike class="strike">') + '</div><div class="box-edit-message">' + newValue + '<br>' + rowdata['editedBy'];
                                                      else {
                                                        strike = newValue.split('<strike>').pop().split('</strike>')[0];
                                                        //alert(strike)
                                                        newValue = newValue.replace(strike,'').replace('<strike></strike>','');
                                                        rowdata['answer'] = strike;
                                                      }

                                                   }
                                              }
                                              collection[key].value = rowdata;
                                          //}
                                      }

  console.log("after html pop")
  console.log(collection);
}
addReportDetails(checklistId,actionDate,actionTime){
  if(checklistId){
    this.allQuestionAnswer =[];
    this.allSectionQuestionAnswer = [];
    this.questionAnswerUser = [];
    //alert(this.vesselId);
    this.checklistreportsService.getChecklistAnswerDetailsByChecklistIdAndDateWithTime(checklistId,actionDate,actionTime,this.vesselId, (response) => {

      console.log("===getChecklistAnswerDetailsByChecklistIdAndDateWithTime===",response)
      var resData = response.data;
        var userIds = [];
        this.reportLoader=false;
        if(resData!=undefined){
           var res = this.modifyedData(response);
           this.allQuestionAnswer = res.data;
          console.log("===this.allQuestionAnswer123===")
          console.log(this.allQuestionAnswer)
        var icon = 0;
          for (var inc=0; inc <this.allQuestionAnswer.length; inc++){
                if(this.allQuestionAnswer[inc].isDelete!=null) continue;
                if(this.allQuestionAnswer[inc].sectionName==null) continue;

                var section = this.allQuestionAnswer[inc].sectionName!=''?this.allQuestionAnswer[inc].sectionName:'new section';
                if(this.in_array(this.allSectionQuestionAnswer, icon+'-'+section)==false) {icon++;}
                this.allSectionQuestionAnswer.push({'section':icon+'-'+section,'value':this.allQuestionAnswer[inc]});
          }

          this.createCollectionLayout(this.allSectionQuestionAnswer);

         console.log(this.allSectionQuestionAnswer);

         //this.sort_by_key(this.allSectionQuestionAnswer,'id');
         this.groupedAnswer = _.groupBy(this.allSectionQuestionAnswer, 'section' );

          userIds.push(response.data[0].userId);
          this.questionAnswerUser = [];
          this.checklistdetails = false;
          this.showReports=true;

          this.checklistreportsService.getChecklistDetailsByChecklistId(checklistId, (response) => {
                     if(response.data){
                              this.revisionDate = response.data.revisionDate;
                              this.checklistToBeAuthorized = response.data.authorityIds.split(",");
                              this.reportHeader= [];
                              if(response.data.reportHeader!=undefined) {
                                  this.reportHeader = response.data.reportHeader.split(",");
                              }
                          }

                    this.checklistreportsService.getChecklistApprovalDetails(checklistId,actionDate,actionTime,this.vesselId, (approvResponse) => {
                     if(approvResponse.data){
                              console.log("checklist approval details")
                              console.log(approvResponse.data)
                              this.approvedIds = approvResponse.data.aughorizedBy;
                              var approvalArray = this.approvedIds.toString().split(",")
                              for(let elem of approvalArray){
                                  var elemArray = elem.toString().split("-");
                                  userIds.push(elemArray[1]);

                              }

                          }

                              //alert(userIds.toString());
                              //Getting User Data Who Have Approved
                           this.checklistreportsService.getCrewByCrewIdList(userIds.toString(),(crewsresponse) => {
                                  console.log("user data available");
                                  console.log(crewsresponse);
                                         if(crewsresponse){
                                             for(var detail of crewsresponse){
                                                this.questionAnswerUser.push(detail.data);
                                             }
                                         }
                                         this.getAllRole();

                                  })

                     })

           })

        }
    })


    this.allHeaderNotes =[];
    this.allFooterNotes =[];
    this.allFooterBottomNotes =[];

    this.checklistreportsService.getAllNotes(checklistId, (response) => {
      var resData = response.data;
      console.log(resData);
      var i=0;var j=0;var k=0;
      if(resData!=undefined){
          for(let row of resData){
             if(row.position=='Header'){
               this.allHeaderNotes.push({'title':row.title, 'description':row.description});
             }
             if(row.position=='Footer'){
               this.allFooterNotes.push({'title':row.title, 'description':row.description});
             }
             if(row.position=='FooterBottom'){
               this.allFooterBottomNotes.push({'title':row.title, 'description':row.description});
             }

          }
      }
      console.log('==allHeaderNotes==');
      console.log(this.allHeaderNotes);

      console.log('==allFooterNotes==');
      console.log(this.allFooterNotes);

      console.log('==allFooterBottomNotes==');
      console.log(this.allFooterBottomNotes);
    })


    this.checklistreportsService.getChecklistAnsAdditionalInfoByChecklistIdWithDateTime(checklistId,actionDate,actionTime,(response) => {
      this.checklistAdditionalInfo = response.data;
      console.log('===checklistAdditionalInfo==');
      console.log(this.checklistAdditionalInfo);
      console.log('===checklistAdditionalInfo11==');

        if(response.data==null){
            this.checklistreportsService.getChecklistAdditionalInfoByChecklistId(checklistId,(response) => {
                console.log('===additional data response===')
                console.log(response)
                this.checklistAdditionalInfo = response.data;
            })

        }
    })


  }
}

downloadPDF(pdfTitle: any){  
  var node = document.getElementById('print-section');
  var newPdfTitle = pdfTitle ? pdfTitle : 'Title';
  const htmlContent = node.innerHTML;
  this.commonService.openDialog(htmlContent, newPdfTitle);
  }

      showReportDetails(actionDate:any){
      this.showReports=true;
      this.checklistdetails = false;
  }

    getSignature(imagedata:any){
      return (imagedata!="" && imagedata!=null)?this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64, '+ imagedata):this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64, 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');
  }


  getAllRole(){
       this.checklistService.getAllRole((response) => {
        var res=response.data;
        console.log('=== All Authorized By====');
        console.log(this.questionAnswerUser);
        this.checklistAuthorizedBy = [];
        if(res){
            this.authorizedBy = res;
            loop1:
            for(var i=0; i<this.checklistToBeAuthorized.length; i++){
                loop2:
                for(let row of res){
                    if(this.checklistToBeAuthorized[i]==row.id){
                        var crewExists = false;
                        loop3:
                        for(var t=0; t<this.questionAnswerUser.length; t++){

                            if(this.questionAnswerUser[t].roleId==row.id){
                                this.checklistAuthorizedBy.push({'id':row.id,'role':row.roleName,'sign':this.questionAnswerUser[t].signatureData,'showbtn':0 ,'name': this.questionAnswerUser[t].firstName + ' ' + this.questionAnswerUser[t].lastName})
                                crewExists = true;
                                break loop3;
                            }
                        }


                        if(!crewExists && this.session.get('rolename').toString().toLowerCase()==row.roleName.toString().toLowerCase()){
                            this.checklistAuthorizedBy.push({'id':row.id,'role':row.roleName,'sign':'','showbtn':1,'name':''})
                        }else if(!crewExists) {
                            this.checklistAuthorizedBy.push({'id':row.id,'role':row.roleName,'sign':'','showbtn':0,'name':''})
                        }

                    }
                }
            }
        }

        setTimeout(() => {
          if (!this.reportLoader && document.getElementById("print-section")) {
            var node = document.getElementById("print-section");
            var bookname = document.getElementById('bookname').innerHTML;
            var pdfLoader = document.getElementById('isPdfLoading');
            // this.commonService.downloadPdfCommonFn(node, bookname, pdfLoader);
            const htmlContent = node.innerHTML;
            this.commonService.openDialog(htmlContent, this.checkListName, '');
           // this.router.navigate(['/downloadreport', { htmlContent }]);
          }
      }, 12000);
    })
  }

  onAuthrorizeSheet(checklist,id){
      var authorizeBy = id +'-'+ this.session.get('userid');
      this.approvalDetail = [];
      if(checklist.length>0){
        //alert('checklist[0].actionTime '+checklist[0].actionTime);
        this.approvalDetail = {"vesselId":checklist[0].vesselId,'checklistId':checklist[0].checklistId,'aughorizedBy':authorizeBy,'actionDate':checklist[0].actionDate,'actionTime':checklist[0].actionTime};
        console.log("=====save array====");
        console.log(this.approvalDetail);
         this.checklistreportsService.saveChecklistApprovalDetails(this.approvalDetail, (data) => {
            if (data.responsecode === 200 || data.responsecode === '200') {
                console.log('============saved successfully============');

                 this.checklistreportsService.getCrewByCrewIdList(this.session.get('userid'),(crewsresponse) => {
                                  console.log("user data available");
                                  console.log(crewsresponse);
                                         if(crewsresponse){
                                             for(var detail of crewsresponse){
                                                this.questionAnswerUser.push(detail.data);
                                             }
                                             this.getAllRole();
                                         }
                                  })
            }
         })
      }
  }

}
